import { SVG } from 'Common/commonsvg';
import React, { useEffect, useState } from 'react';
import { getSingleFolder } from '../DAM_API/urls';
import Axios from 'functions/Axios';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { setHierarchyFolderData } from 'actions/damActions';
import WordWrapEllipse from '../WordWrapEllipse';

const FolderNode = ({ node, onNodeClick, InsideData, activeId, HandleInsideData, Index }) => {
  const [isOpen, setIsOpen] = useState(node.isOpen ?? false);
  const [innerFolderData, setInnerFolderData] = useState();
  let hasChildren;

  const handleToggleClick = (e) => {
    e.stopPropagation();
    setIsOpen(!isOpen);
  };

  const handleNameClick = async () => {
    const result = await Axios.get(getSingleFolder + node.id);
    hasChildren = result?.data?.data?.folders?.length > 0;
    setInnerFolderData(result?.data?.data?.folders?.[0]?.subfolders);
    InsideData && InsideData(result?.data?.data);
    setIsOpen(!isOpen);
    onNodeClick(node);
  };

  return (
    <div style={{ marginTop: 8, marginLeft: 16 }}>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          cursor: 'pointer',
          backgroundColor: node.id === activeId ? '#f2f2f2' : 'transparent',
          color: node.id === activeId ? '#000000' : '#929292',
          padding: '4px 8px',
          borderRadius: '4px',
          fontWeight: node.id === activeId ? '500' : '400',
        }}
        onClick={handleNameClick}
      >
        <span
          onClick={handleToggleClick}
          style={{
            display: 'inline-block',
            transition: 'transform 0.2s ease',
            marginRight: 10,
            fontSize: 12,
            width: 12,
            textAlign: 'center',
          }}
        >
          {SVG?.folderinlargeViewIcons}
        </span>
        {/* {hasChildren ? (
          <span
            onClick={handleToggleClick}
            style={{
              display: 'inline-block',
              transition: 'transform 0.2s ease',
              marginRight: 10,
              fontSize: 12,
              width: 12,
              textAlign: 'center',
            }}
          >
            {isOpen ? SVG?.keyBoardArrowLeftIcon : SVG?.keyBoardArrowRightIcon}
          </span>
        ) : (
          <span style={{ width: 12, marginRight: 10 }} />
        )} */}

        {/* Folder icon and name */}
        <span style={{ display: 'flex', alignItems: 'center' }}>
          {hasChildren ? (isOpen ? SVG?.openFolder : SVG?.closedFolder) : SVG?.selectedFoldeSvgIcon}
          &nbsp;
          <WordWrapEllipse Text={node.folderName} MaxWidth={'10ch'} />
        </span>
      </div>

      {/* Recursive render of children if folder is open */}
      {isOpen && innerFolderData?.length > 0 && (
        <div>
          {innerFolderData.map((child) => (
            <FolderNode
              key={child.id}
              node={child}
              onNodeClick={onNodeClick}
              activeId={activeId}
              InsideData={HandleInsideData}
            />
          ))}
        </div>
      )}
    </div>
  );
};

// Main folder tree component
const CustomFolderTree = ({ data, HandleSelectid, HandleInsideData }) => {
  const [activeId, setActiveId] = useState(data?.children?.[0]?.id);
  const { HierarchyFolderData } = useSelector((state) => state.dam);
  const dispatch = useDispatch();

  const handleNodeClick = (node) => {
    if (node.isFirstFolder) {
      dispatch(setHierarchyFolderData([node]));
    } else {
      const hierarhedfolderdata = HierarchyFolderData;

      if (
        HierarchyFolderData?.[HierarchyFolderData?.length - 2]?.subfolders?.some(
          (item) => item?.id === node?.id,
        )
      ) {
        hierarhedfolderdata?.length > 1 && hierarhedfolderdata.pop();
      }

      hierarhedfolderdata.push(node);
      dispatch(setHierarchyFolderData(hierarhedfolderdata));
    }

    setActiveId(node?.id);
    HandleSelectid && HandleSelectid(node);
  };

  useEffect(() => {
    setActiveId(data?.children?.[0]?.id);
  }, [data]);

  return (
    <div>
      {data?.map((node, Index) => (
        <FolderNode
          key={node.id}
          node={node}
          onNodeClick={handleNodeClick}
          activeId={activeId}
          InsideData={HandleInsideData}
          HandleInsideData={HandleInsideData}
        />
      ))}
    </div>
  );
};

export default CustomFolderTree;
